module.exports = __webpack_public_path__ + "img/744.66bd4a78.jpg";